const MAX_SIZE = 1380;

type LoadedImage = {
    image: HTMLImageElement
    objectUrl: string
}

const loadImageFromFile = (file: File): Promise<LoadedImage> => new Promise((resolve, reject) => {
    const objectUrl = URL.createObjectURL(file)
    const image = new Image()

    image.onload = () => resolve({ image, objectUrl })
    image.onerror = () => {
        URL.revokeObjectURL(objectUrl)
        reject(new Error('خطا در بارگذاری تصویر'))
    }

    image.src = objectUrl
})

const canvasToBlob = (canvas: HTMLCanvasElement, fileType: string): Promise<Blob> => new Promise((resolve, reject) => {
    canvas.toBlob(blob => {
        if (!blob) {
            reject(new Error('خطا در فشرده سازی تصویر'))
            return
        }

        resolve(blob)
    }, fileType, 0.9)
})


export const resizeImageIfNeeded = async (file: File): Promise<File> => {
    if (!file?.type?.startsWith('image/')) {
        return file
    }

    const { image, objectUrl } = await loadImageFromFile(file)

    try {
        const largestSide = Math.max(image.width, image.height)
        if (largestSide <= MAX_SIZE) {
            return file
        }

        const scale = MAX_SIZE / largestSide
        const width = Math.round(image.width * scale)
        const height = Math.round(image.height * scale)

        const canvas = document.createElement('canvas')
        canvas.width = width
        canvas.height = height

        const context = canvas.getContext('2d')
        if (!context) {
            throw new Error('خطا در پردازش تصویر')
        }

        context.drawImage(image, 0, 0, width, height)

        const resizedBlob = await canvasToBlob(canvas, file.type)

        return new File([resizedBlob], file.name, {
            type: resizedBlob.type || file.type,
            lastModified: file.lastModified,
        })
    } finally {
        URL.revokeObjectURL(objectUrl)
    }
}